<template>
    <user-team-card
        :lead="props.lead"
        :user="props.lead.assignee.user"
        :team="props.lead.assignee.team"
        :assignable-users="assignableResponsibleUsers"
        :editable="isUserOfAssignedCompany && Status.OPEN.equals(props.lead.status)"
        :forwardable="isUserOfAssignedCompany && Status.OPEN.equals(props.lead.status)"
        @user-change="changeResponsible($event)"
    >
        <template #title>
            Verantwoordelijk
        </template>
    </user-team-card>
</template>

<script lang="ts" setup>
    import { Lead, Status, User } from '@keyvue/one-api-client';
    import useClient from '@composables/useClient';
    import useLeadSecurity from '@composables/security/useLeadSecurity';
    import { computed } from 'vue';
    import { createResourceIdentifier, Referral, ReferralAPI } from '@keyvue/one-api-client-legacy';
    import useNotify from '@composables/useNotify';
    import useEventBus from '@composables/useEventBus';
    import UserTeamCard from '@components/Cards/UserTeamCard.vue';

    interface Props {
        lead: Lead;
    }

    const props = defineProps<Props>();
    const { client } = useClient();
    const { isUserOfAssignedCompany } = await useLeadSecurity(props.lead);
    const { notifySaving, notifySaved } = useNotify();
    const eventBus = useEventBus();

    const [
        assignableResponsibleUserCollection,
    ] = await Promise.all([
        await client.getSubResources(props.lead.assignee.team, User, 'available-users'),
    ]);

    const assignableResponsibleUsers = computed(() => assignableResponsibleUserCollection.data);

    const changeReferralField = async (callback: (referral: Referral) => Referral) => {
        const closeNotification = notifySaving(undefined, 0);
        const legacyReferral = await ReferralAPI.get(props.lead.id.value);
        await ReferralAPI.update(props.lead.id.value, callback(legacyReferral));
        notifySaved();
        if (closeNotification) {
            closeNotification();
        }
    };

    const changeResponsible = async (user: User) => {
        await changeReferralField((referral) => {
            const localReferral = referral;
            localReferral.assignedTo = createResourceIdentifier('users', user.id.value);
            return localReferral;
        });

        eventBus.dispatch('resource-manipulated', 'Lead');
    };
</script>
